import React from "react";
import Home from "./home";

const LandingPage: React.FC = () => {
  return (
    <>
      <Home />
    </>
  );
};

export default LandingPage;
